import { AboutPage } from "@/features/hca-public";
import { PublicShellWithDiagnoza } from "@/route-helpers/public-shell-with-diagnoza";
import { usePageMeta } from "@/shared/seo/use-page-meta";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/o-nas")({
  component: AboutRoute,
});

function AboutRoute() {
  usePageMeta({
    title: "O nás",
    description:
      "Přes 30 let pomáháme firmám růst. Poznejte příběh, hodnoty a výsledky HCA Moravia — partnera pro executive vzdělávání a rozvoj managementu.",
    path: "/o-nas",
  });
  return (
    <PublicShellWithDiagnoza>
      <AboutPage />
    </PublicShellWithDiagnoza>
  );
}
